export default "__VITE_ASSET__n_Bla1y4__"